const pad = (n: number): string => n.toString().padStart(2, "0");

export const formatPlayerTime = (numSeconds: number): string => {
  const hours = Math.floor(numSeconds / 60 / 60);
  const minutes = Math.floor(numSeconds / 60);
  const seconds = Math.floor(numSeconds % 60);
  return (hours > 0 ? `${pad(hours)}:` : "") + `${pad(minutes)}:` + pad(seconds);
};
